import Measurement from './Measurement';
import TireNote from './TireNote';

export default class Brake {
  discMeasurement: Measurement | null = null;
  padMeasurement: Measurement | null = null;
  note: TireNote | null = null;

  static withData(data: Partial<Brake>): Brake {
    return Object.assign(new Brake(), data);
  }
}
